import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Takoj&Zdaj",
  "description": "",
  "published": "2006-11-28T00:00:00.000Z",
  "redirect_from": ["/blog/takojzdaj/swizec/347"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Vau (se vedno se pocutim neumno kadar ta medmet napisem v slovenscini), sploh si ne morete predstavljati kako cas bezi, ko skusas najti nacin, da spravis dovolj ur v dan in tako ustvaris moznost koncanja vseh potrebnih opravil do bozica. Hec je v tem, da sem se verjetno pogreznil pregloboko. Obstaja namrec dobro placan projekt, ki ga je treba koncati do bozica, potem pa je temu prilepljena se majhna tezava treh slik, ki sem se jih namernil ustvariti za praznicna darila.`}</p>
    <p>{`Vse skupaj se menda zakljuci z dejstvom, da bo strip koncan in posodobljen pravocasno, v nekako treh dneh, in da bodo novice postale malce bolj raztrescene, anglezi bi rekli, da se bodo pojavljale `}<em parentName="p">{`now and anon`}</em>{`.`}</p>
    <p>{`Vecina ljudi tega idioma sicer ne pozna, vendar je po mojem okusu najboljsi v obstoju. Vzemimo ga torej popolnoma direktno in recimo, da `}<em parentName="p">{`now`}</em>{` v slovenscini pomeni nekako zdaj ali celo zdajle, `}<em parentName="p">{`anon`}</em>{` pa pomeni takoj ali zdajci. Ce jih povezemo dobimo nekaj, kar je na videz popoln oksimoron, vendar pa se izkaze, da pomeni obcasno in brez reda ... fantasticen jezik.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      